import { Copy, SvgMagnifyingGlass } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';

export interface GroupSearchInputProps {
  name: string;
  id: string;
}

export function GroupSearchInput({
  name,
  id,
}: GroupSearchInputProps): JSX.Element {
  const { errors, control } = useFormContext();

  return (
    <CookbookInputWrapper
      name={name}
      id={id}
      inputSize="small"
      control={control}
      error={errors[name]}
      blockWidth
      aria-label={name}
      placeholder="Search by group name"
      prefixDecorator={
        <Copy variant="body" color="secondaryText">
          <SvgMagnifyingGlass size="16px" />
        </Copy>
      }
    />
  );
}
